import { Link } from "@phosphor-icons/react";
import { Handle, Position } from "@xyflow/react";
import clsx from "clsx";

export type LinkNodeData = {
    label: string;
    value: string;
    onClick?: () => void;
    className: string;
};

export const LinkNode = ({
    data,
    targetPosition,
    sourcePosition,
}: {
    data: LinkNodeData;
    targetPosition?: Position;
    sourcePosition?: Position;
}) => {
    return (
        <div
            className={clsx(
                "px-4 py-2 shadow-md rounded-md border-1 border-stone-400",
                data.onClick
                    ? "hover:cursor-pointer hover:bg-soft-green-40"
                    : "hover:cursor-grab",
                data.className
            )}
            onClick={data.onClick}
        >
            <div className="flex flex-row items-center gap-1">
                {targetPosition && (
                    <Handle type="target" position={targetPosition} />
                )}
                <div className="flex flex-col">
                    <span>{data.label}</span>
                    <span>{data.value}</span>
                </div>
                {data.onClick && <Link size={20} />}
                {sourcePosition && (
                    <Handle type="source" position={sourcePosition} />
                )}
            </div>
        </div>
    );
};
